(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["game-product-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-game-row')) {
    customElements.define(
      'sf-game-row',
      class SfGameRow extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-sf-row-track]');
          this.tabs = [...this.querySelectorAll('.sf-tab')];
          this.prev = this.querySelector('[data-sf-row-prev]');
          this.next = this.querySelector('[data-sf-row-next]');
          this.cache = new Map();
          this._started = false;
          if (!this.track) return;

          this.prev?.addEventListener('click', () => this.scrollBy(-1));
          this.next?.addEventListener('click', () => this.scrollBy(1));
          this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', (event) => {
              if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
              event.preventDefault();
              this.start(tab);
            });
          });

          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                io.disconnect();
                this.start();
              },
              { rootMargin: '900px 0px' }
            );
            io.observe(this);
          } else {
            this.start();
          }
        }

        start(tab) {
          if (this._started) {
            if (tab) this.selectTab(tab);
            return;
          }
          this._started = true;
          if (this.dataset.mixUrls) {
            this.loadMix();
            return;
          }
          if (this.tabs.length === 0) return;
          const initial =
            tab || this.tabs.find((item) => item.getAttribute('aria-selected') === 'true') || this.tabs[0];
          this.selectTab(initial);
        }

        async fetchItemHtml(url) {
          const cached = this.cache.get(url);
          if (cached !== undefined) return cached;

          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          const raw = response.ok ? await response.text() : '';
          const parsed = new DOMParser().parseFromString(raw, 'text/html');
          const html = [...parsed.querySelectorAll('.sf-row__item')].map((item) => item.outerHTML);
          this.cache.set(url, html);
          return html;
        }

        async loadMix() {
          const urls = (this.dataset.mixUrls || '')
            .split('||')
            .map((url) => url.trim())
            .filter(Boolean);
          const limit = Number(this.dataset.mixLimit) || 8;
          if (!urls.length) return;

          this.track.setAttribute('aria-busy', 'true');
          try {
            const lists = await Promise.all(urls.map((url) => this.fetchItemHtml(url)));
            const mixed = [];
            const max = Math.max(0, ...lists.map((list) => list.length));
            for (let index = 0; index < max; index++) {
              for (const list of lists) {
                if (list[index]) mixed.push(list[index]);
              }
            }
            const html = mixed.slice(0, limit).join('');
            this.track.innerHTML = html || `<p class="sf-row__empty">${this.dataset.empty || ''}</p>`;
            this.track.scrollTo({ left: 0 });
            this.syncArrows();
          } catch (error) {
            this.track.innerHTML = `<p class="sf-row__empty">${this.dataset.empty || ''}</p>`;
          } finally {
            this.track.removeAttribute('aria-busy');
          }
        }

        async selectTab(tab) {
          this.tabs.forEach((item) => {
            const on = item === tab;
            item.classList.toggle('sf-tab--active', on);
            item.setAttribute('aria-selected', on ? 'true' : 'false');
          });

          const url = tab.getAttribute('data-cards-url');
          if (!url) return;

          this.track.setAttribute('aria-busy', 'true');
          try {
            const items = await this.fetchItemHtml(url);
            const html = items.join('');
            this.track.innerHTML = html || `<p class="sf-row__empty">${this.dataset.empty || ''}</p>`;
            this.track.scrollTo({ left: 0 });
            this.syncArrows();
          } catch (error) {
            this.track.innerHTML = `<p class="sf-row__empty">${this.dataset.empty || ''}</p>`;
          } finally {
            this.track.removeAttribute('aria-busy');
          }
        }

        scrollBy(direction) {
          const amount = this.track.clientWidth * 0.8 * direction;
          this.track.scrollBy({ left: amount, behavior: 'smooth' });
        }

        syncArrows() {
          if (!this.prev || !this.next) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 4;
          this.prev.disabled = this.track.scrollLeft <= 4;
          this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["game-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-game-shop')) {
    customElements.define(
      'sf-game-shop',
      class SfGameShop extends HTMLElement {
        connectedCallback() {
          this._items = [];
          this._shown = 0;
          this._sort = 'popular';
          this._pageTitle = document.title;
          this._pageSize = window.matchMedia('(max-width: 749px)').matches ? 24 : 36;
          this.bindBrowse();
          this.bindAisleNav();
          this.normalizeAisleUrl();
          this.applyAisleFromUrl({ scroll: false, browse: false });
          const url = this.dataset.catalogUrl;
          if (!url) return;
          this.fetchCatalog(url).catch(() => {
            this._items = [...this.querySelectorAll('[data-shop-grid] > .sf-row__item')];
            this.build(this._items, true);
          });
        }

        async fetchCatalog(url) {
          const first = await fetch(url, { credentials: 'same-origin' });
          if (!first.ok) throw new Error('catalog');
          const html = await first.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this._items = [...doc.querySelectorAll('.sf-row__item')];
          const pages = Number(doc.querySelector('[data-sf-catalog]')?.dataset.pages || 1);
          this.build(this._items, true);

          const loadRest = async () => {
            for (let page = 2; page <= pages; page += 1) {
              const response = await fetch(`${url}&page=${page}`, { credentials: 'same-origin' });
              if (!response.ok) continue;
              const pageDoc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const more = [...pageDoc.querySelectorAll('.sf-row__item')];
              if (more.length === 0) continue;
              const start = this._items.length;
              more.forEach((item, index) => {
                item.dataset.index = String(start + index);
              });
              this._items.push(...more);
              this.syncMoreButton();
            }
            this.afterCatalogGrow();
          };

          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
              loadRest();
            }, { timeout: 1500 });
          } else {
            window.setTimeout(loadRest, 250);
          }
        }

        filteredItems() {
          const query = (this.querySelector('[data-shop-filter]')?.value || '').trim().toLowerCase();
          const showOos = Boolean(this.querySelector('[data-show-oos]')?.checked);
          const aisle = this.activeAisle();
          const items = aisle ? this.groupItems(this._items)[aisle] || [] : this._items;
          const visible = items.filter((item) => {
            if (!showOos && item.dataset.available === '0') return false;
            if (query && !this.titleMatchesQuery(item.dataset.title, query)) return false;
            return true;
          });
          if (this._sort === 'popular' && !aisle && !query) return this.frontMix(visible);
          return visible.sort((a, b) => this.compareItems(a, b));
        }

        itemPrice(item) {
          return Number(item.dataset.price || 0);
        }

        isBrowseMixPrice(item) {
          const price = this.itemPrice(item);
          return price >= 200 && price <= 1000;
        }

        mixKey(item) {
          const handle = item.dataset.handle || item.dataset.title || '';
          let hash = 0;
          for (let i = 0; i < handle.length; i += 1) {
            hash = (hash * 31 + handle.charCodeAt(i)) >>> 0;
          }
          return hash;
        }

        frontMix(items) {
          const mid = [];
          const rest = [];
          items.forEach((item) => {
            if (this.isBrowseMixPrice(item)) mid.push(item);
            else rest.push(item);
          });
          mid.sort((a, b) => this.mixKey(a) - this.mixKey(b) || (a.dataset.title || '').localeCompare(b.dataset.title || ''));
          rest.sort((a, b) => Number(a.dataset.index || 0) - Number(b.dataset.index || 0));
          return [...mid, ...rest];
        }

        syncMoreButton() {
          const more = this.querySelector('[data-load-more]');
          if (!more) return;
          more.hidden = this._shown >= this.filteredItems().length;
        }

        build(items, resetBrowse) {
          if (items.length === 0) return;
          this.indexItems(items);
          this.renderAisles(items, true);
          this.fillHomeRows();
          this.applyAisleFromUrl({ scroll: false, browse: resetBrowse });
        }

        afterCatalogGrow() {
          this.indexItems(this._items);
          this.renderAisles(this._items, false);
          this.fillHomeRows();
          this.applyAisleFromUrl({ scroll: false, browse: false });
          this.renderBrowse(false);
          this.syncHeading();
        }

        indexItems(items) {
          items.forEach((item, index) => {
            item.dataset.index = String(index);
          });
        }

        fillHomeRows() {
          if (!this.isHomeShop()) return;
          const newTitles = this.newItemTitles();
          const bestTitles = this.bestsellerTitles();
          const skip = new Set([...newTitles, ...bestTitles]);
          const cheapExtras = this._items.filter((item) => {
            const title = (item.dataset.title || '').trim().toLowerCase();
            const price = Number(item.dataset.price || 0);
            return !skip.has(title) && price >= 199 && price <= 1500;
          });
          this.fillHomeStrip(
            this.querySelector('[data-bestsellers]'),
            this.querySelector('[data-bestsellers-track]'),
            bestTitles,
            cheapExtras
          );
          this.fillHomeStrip(
            this.querySelector('[data-trending]'),
            this.querySelector('[data-trending-track]'),
            newTitles,
            this.groupItems(this._items).new || []
          );
        }

        newItemTitles() {
          return [
            'heart wand knife',
            'beach bundle',
            'sands gun',
            'beachy knife',
            'chroma icecream',
            'chroma heart wand knife',
            'chroma treat gun',
            'chroma sands gun',
            'chroma sweet knife',
            'chroma sweet treat bundle',
            'chroma beachy knife',
            'chroma beach bundle',
            'treat gun',
            'sweet knife',
            'icecream',
            'sweet treat bundle',
          ];
        }

        bestsellerTitles() {
          return [
            'heartblade',
            'bat',
            'harvester',
            'phantom & spectre bundle',
            'icepiercer',
            'icewing',
            'chroma lightbringer gun',
            'chroma swirly gun',
            'cookie bundle',
            'battleaxe knife',
            'xmas',
            'icebreaker',
            'chroma fang',
            'chroma heat',
            'jd',
            'seer',
          ];
        }

        fillHomeStrip(wrap, track, wanted, extras) {
          if (!wrap || !track || this._items.length === 0) return;

          const byTitle = new Map();
          this._items.forEach((item) => {
            const title = (item.dataset.title || '').trim().toLowerCase();
            if (title && !byTitle.has(title)) byTitle.set(title, item);
          });

          const seen = new Set();
          const list = [];
          const take = (item) => {
            if (!item || list.length >= 16) return;
            const handle = item.dataset.handle;
            if (!handle || seen.has(handle) || item.dataset.available === '0') return;
            seen.add(handle);
            list.push(item);
          };

          wanted.forEach((title) => take(byTitle.get(title)));
          (extras || []).forEach((item) => take(item));
          if (list.length === 0) return;

          track.replaceChildren(...list.map((node) => node.cloneNode(true)));
          this.primeImages(track, 16);
          wrap.hidden = false;
          this.bindAisle(wrap);
        }

        aisleKeys() {
          return [
            'new',
            'sale',
            'godlys',
            'chromas',
            'knives',
            'guns',
            'bundles',
            'pets',
            'misc',
          ];
        }

        activeAisle() {
          const params = new URLSearchParams(window.location.search);
          const fromUrl = (params.get('aisle') || '').toLowerCase();
          if (this.aisleKeys().includes(fromUrl)) return fromUrl;
          const start = (this.dataset.startAisle || '').toLowerCase();
          if (this.aisleKeys().includes(start)) return start;
          const inferred = this.aisleFromSearchQuery(params.get('q') || '');
          return this.aisleKeys().includes(inferred) ? inferred : '';
        }

        aisleFromSearchQuery(query) {
          const extra = String(query || '')
            .toLowerCase()
            .replace(/vendor\s*:\s*"[^"]*"/g, ' ')
            .replace(/vendor\s*:\s*'[^']*'/g, ' ')
            .replace(/vendor\s*:[^&]*/g, ' ')
            .replace(/[+"']/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
          if (!extra) return '';
          if (/\bbundles?\b/.test(extra)) return 'bundles';
          if (/\bguns?\b/.test(extra)) return 'guns';
          if (/\bknives?\b|\bknife\b/.test(extra)) return 'knives';
          if (/\bchromas?\b/.test(extra)) return 'chromas';
          if (/\bgodlys?\b/.test(extra)) return 'godlys';
          if (/\bpets?\b/.test(extra)) return 'pets';
          return '';
        }

        normalizeAisleUrl() {
          const aisle = this.activeAisle();
          const current = new URLSearchParams(window.location.search).get('aisle') || '';
          if (!aisle || current === aisle) return;
          window.history.replaceState({ aisle }, '', this.aisleUrl(aisle));
        }

        aisleUrl(key) {
          const url = new URL(this.dataset.shopUrl || window.location.href, window.location.origin);
          if (key && key !== 'all') url.searchParams.set('aisle', key);
          else url.searchParams.delete('aisle');
          return `${url.pathname}${url.search}`;
        }

        aisleLabel(key) {
          if (!key || key === 'all') return this.dataset.shopName || '';
          return this.querySelector(`[data-aisle="${key}"] h2`)?.textContent?.trim() || key;
        }

        bindAisleNav() {
          if (this._aisleNavBound) return;
          this._aisleNavBound = true;
          this.addEventListener('click', (event) => {
            const link = event.target.closest('[data-aisle-link], [data-chip], [data-shop-back]');
            if (!link || !this.contains(link)) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
              return;
            }
            event.preventDefault();
            const key = link.hasAttribute('data-shop-back')
              ? 'all'
              : link.dataset.aisleLink || link.dataset.chip || 'all';
            this.openAisle(key);
          });
          window.addEventListener('popstate', () => {
            this.applyAisleFromUrl({ scroll: true, browse: true });
          });
        }

        isHomeShop() {
          return this.classList.contains('sf-shop--home');
        }

        scrollShop() {
          if (this.isHomeShop()) {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          window.scrollTo(0, 0);
        }

        openAisle(key) {
          const next = key && key !== 'all' ? key : '';
          if (this.activeAisle() === next) {
            this.applyAisleFromUrl({ scroll: true, browse: true });
            return;
          }
          window.history.pushState({ aisle: next }, '', this.aisleUrl(next || 'all'));
          this.applyAisleFromUrl({ scroll: true, browse: true });
        }

        applyAisleFromUrl({ scroll = false, browse = true } = {}) {
          const aisle = this.activeAisle();
          this.classList.toggle('sf-shop--category', Boolean(aisle));
          this.syncChips();
          this.syncHeading();
          if (browse && this._items.length) this.renderBrowse(true);
          if (scroll) this.scrollShop();
        }

        syncChips() {
          const aisle = this.activeAisle();
          this.querySelectorAll('[data-shop-chips] [data-chip]').forEach((chip) => {
            chip.classList.toggle('is-active', chip.dataset.chip === (aisle || 'all'));
          });
        }

        syncHeading() {
          const aisle = this.activeAisle();
          const shopName = this.dataset.shopName || '';
          const title = this.querySelector('[data-shop-title]');
          const back = this.querySelector('[data-shop-back]');
          const label = this.aisleLabel(aisle);
          if (title) title.textContent = aisle ? label : shopName;
          if (back) back.hidden = !aisle;
          if (this._items.length) {
            const n = this.filteredItems().length;
            const text = n === 1 ? '1 product' : `${n} products`;
            this.querySelectorAll('[data-shop-count]').forEach((count) => {
              count.hidden = n < 1;
              count.textContent = text;
            });
          }
          if (!this.isHomeShop()) {
            document.title = aisle && label ? `${label} · ${shopName}` : this._pageTitle;
          }
        }

        groupItems(items) {
          const bestsellerTag = (this.dataset.bestsellerTag || '').toLowerCase();
          const newTag = (this.dataset.newTag || '').toLowerCase();
          const grouped = {
            bestsellers: [],
            new: [],
            sale: [],
            godlys: [],
            chromas: [],
            knives: [],
            guns: [],
            bundles: [],
            pets: [],
            misc: [],
          };

          const newest = [...items].sort(
            (a, b) => Number(b.dataset.published || 0) - Number(a.dataset.published || 0)
          );
          grouped.new = newest.slice(0, 48);

          const knifeRe =
            /(knife|knives|dagger|sickle|scythe|katana|cleaver|blade|axe|fang|shard|saw|icewing|batwing|logchopper|candy|pixel|xmas|tides|chill|gemstone|clockwork|candleflame|sugar|prismatic|corrupt|slasher|\bheat\b|ghost|pumpking|shadow|minty|spider|america|icebreaker|\bjd\b|glory)/;
          const gunRe =
            /\b(gun|guns|luger|bloxbro|bloxbros|laser|shotgun|rifle|pistol|plasma|cannon|revolver|blaster|icepiercer|icebeam|iceblaster|phaser|lightbringer|darkbringer|shark|jinglegun|lugercane)\b/;
          const bundleRe = /\b(bundles?|sets?|packs?)\b/;
          const petRe = /\b(pets?|dragon|unicorn|kitten|puppy)\b/;
          const notKnife = /^(harvester)$/;

          items.forEach((item) => {
            const title = (item.dataset.title || '').toLowerCase();
            const type = (item.dataset.type || '').toLowerCase();
            const tags = (item.dataset.tags || '').toLowerCase();
            const hay = `${title} ${type} ${tags}`;
            if (item.dataset.compare === '1') grouped.sale.push(item);
            if (bestsellerTag && tags.includes(bestsellerTag)) grouped.bestsellers.push(item);
            if (newTag && tags.includes(newTag) && !grouped.new.includes(item)) grouped.new.push(item);
            if (/\bgodly\b/.test(hay)) grouped.godlys.push(item);
            if (/\bchroma\b/.test(hay)) grouped.chromas.push(item);
            if (notKnife.test(title)) {
              if (bundleRe.test(hay)) grouped.bundles.push(item);
              else if (gunRe.test(hay) || /\b(bow|crossbow)\b/.test(hay)) grouped.guns.push(item);
            } else if (/\bknife\b/.test(hay)) {
              grouped.knives.push(item);
            } else if (bundleRe.test(hay)) {
              grouped.bundles.push(item);
            } else if (gunRe.test(hay)) {
              grouped.guns.push(item);
            } else if (knifeRe.test(hay) || title === 'bat' || title.includes('vampire')) {
              grouped.knives.push(item);
            } else if (petRe.test(hay) && !/\bbatwing\b/.test(title)) {
              grouped.pets.push(item);
            }
          });

          if (grouped.bestsellers.length === 0) grouped.bestsellers = items.slice(0, 12);

          const typed = new Set([...grouped.knives, ...grouped.guns, ...grouped.bundles, ...grouped.pets]);
          grouped.misc = items.filter((item) => !typed.has(item));
          return grouped;
        }

        addChip(key, label) {
          const chips = this.querySelector('[data-shop-chips]');
          if (!chips || chips.querySelector(`[data-chip="${key}"]`)) return;
          const chip = document.createElement('a');
          chip.className = 'sf-shop__chip';
          chip.dataset.chip = key;
          chip.href = this.aisleUrl(key);
          chip.textContent =
            label ||
            this.querySelector(`[data-aisle="${key}"] h2`)?.textContent?.trim() ||
            key;
          chips.append(chip);
          chips.hidden = false;
        }

        fillAisle(key, list, reset) {
          const aisle = this.querySelector(`[data-aisle="${key}"]`);
          if (!aisle || list.length === 0) return;
          const track = aisle.querySelector('[data-aisle-track]');
          if (!track) return;

          if (reset) {
            const clones = list.slice(0, 12).map((node) => node.cloneNode(true));
            track.replaceChildren(...clones);
            this.primeImages(track, 4);
          } else {
            const have = track.children.length;
            if (have >= 12) return;
            const existing = new Set([...track.children].map((node) => node.dataset.handle));
            const extras = list
              .filter((node) => !existing.has(node.dataset.handle))
              .slice(0, 12 - have)
              .map((node) => node.cloneNode(true));
            if (extras.length === 0) return;
            track.append(...extras);
            this.primeImages(track, 4);
          }

          aisle.hidden = false;
          aisle.id = `sf-aisle-${key}`;
          this.bindAisle(aisle);
          this.addChip(key);
        }

        renderAisles(items, reset) {
          const grouped = this.groupItems(items);
          const chips = this.querySelector('[data-shop-chips]');
          if (chips) chips.hidden = false;
          if (reset) {
            this.querySelectorAll('[data-aisle]').forEach((aisle) => {
              if (aisle.dataset.aisle === 'all') return;
              aisle.hidden = true;
              aisle.querySelector('[data-aisle-track]')?.replaceChildren();
            });
          }
          this.aisleKeys().forEach((key) => this.fillAisle(key, grouped[key] || [], reset));
          this.syncChips();
        }

        bindAisle(aisle) {
          if (aisle.dataset.bound === '1') return;
          aisle.dataset.bound = '1';
          const track = aisle.querySelector('[data-aisle-track]');
          const prev = aisle.querySelector('[data-aisle-prev]');
          const next = aisle.querySelector('[data-aisle-next]');
          if (!track) return;

          const amount = () => Math.max(track.clientWidth * 0.85, 220);
          prev?.addEventListener('click', () => {
            track.scrollBy({ left: -amount(), behavior: 'smooth' });
          });
          next?.addEventListener('click', () => {
            track.scrollBy({ left: amount(), behavior: 'smooth' });
          });

          const sync = () => {
            const max = track.scrollWidth - track.clientWidth - 4;
            if (prev) prev.disabled = track.scrollLeft <= 4;
            if (next) next.disabled = max <= 0 || track.scrollLeft >= max;
          };
          track.addEventListener('scroll', sync, { passive: true });
          requestAnimationFrame(sync);
        }

        bindBrowse() {
          if (this._browseBound) return;
          this._browseBound = true;

          this.querySelector('[data-browse-search]')?.addEventListener('submit', (event) => {
            event.preventDefault();
          });
          let filterTimer = 0;
          this.querySelector('[data-shop-filter]')?.addEventListener('input', () => {
            window.clearTimeout(filterTimer);
            filterTimer = window.setTimeout(() => this.renderBrowse(true), 160);
          });
          this.querySelector('[data-show-oos]')?.addEventListener('change', () => this.renderBrowse(true));
          this.querySelector('[data-load-more]')?.addEventListener('click', () => {
            this._shown += this._pageSize;
            this.renderBrowse(false);
          });

          const sortRoot = this.querySelector('[data-sort]');
          const toggle = this.querySelector('[data-sort-toggle]');
          const menu = this.querySelector('[data-sort-menu]');
          if (!sortRoot || !toggle || !menu) return;

          const close = () => {
            menu.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
          };
          const open = () => {
            menu.hidden = false;
            toggle.setAttribute('aria-expanded', 'true');
          };

          toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            if (menu.hidden) open();
            else close();
          });
          menu.addEventListener('click', (event) => {
            const option = event.target.closest('[data-sort-value]');
            if (!option) return;
            this._sort = option.dataset.sortValue || 'popular';
            menu.querySelectorAll('[data-sort-value]').forEach((button) => {
              button.setAttribute('aria-selected', button === option ? 'true' : 'false');
            });
            const label = this.querySelector('[data-sort-label]');
            if (label) label.textContent = option.textContent.trim();
            close();
            this.renderBrowse(true);
          });
          document.addEventListener('click', (event) => {
            if (!sortRoot.contains(event.target)) close();
          });
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') close();
          });
        }

        compareItems(a, b) {
          switch (this._sort) {
            case 'price-asc': {
              const byPrice = Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
              return byPrice !== 0 ? byPrice : (a.dataset.title || '').localeCompare(b.dataset.title || '');
            }
            case 'price-desc': {
              const byPrice = Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
              return byPrice !== 0 ? byPrice : (a.dataset.title || '').localeCompare(b.dataset.title || '');
            }
            case 'name-asc':
              return (a.dataset.title || '').localeCompare(b.dataset.title || '');
            case 'name-desc':
              return (b.dataset.title || '').localeCompare(a.dataset.title || '');
            default:
              return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
          }
        }

        primeImages(root, limit = 6) {
          if (!root) return;
          [...root.querySelectorAll('img')].slice(0, limit).forEach((image, index) => {
            image.loading = 'eager';
            if (index < 2) image.fetchPriority = 'high';
          });
        }

        titleMatchesQuery(title, query) {
          const t = (title || '').toLowerCase();
          const q = (query || '').trim().toLowerCase();
          if (!q) return true;
          if (t.includes(q)) return true;
          const stem = (value) => value.replace(/s\b/g, '');
          if (stem(t).includes(stem(q))) return true;
          return q.split(/\s+/).every((word) => t.includes(word) || stem(t).includes(stem(word)));
        }

        renderBrowse(reset = false) {
          const grid = this.querySelector('[data-shop-grid]');
          if (!grid || this._items.length === 0) return;

          const visible = this.filteredItems();

          if (reset || this._shown < 1) this._shown = Math.min(this._pageSize, visible.length);
          else this._shown = Math.min(Math.max(this._shown, this._pageSize), visible.length);

          grid.replaceChildren(...visible.slice(0, this._shown));
          this.primeImages(grid, this._pageSize);
          const empty = this.querySelector('[data-browse-empty]');
          if (empty) empty.hidden = visible.length > 0;
          const more = this.querySelector('[data-load-more]');
          if (more) more.hidden = this._shown >= visible.length;
          this.syncHeading();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-game-items"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-related-row')) {
    customElements.define(
      'sf-related-row',
      class SfRelatedRow extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-sf-related-track]');
          const url = this.dataset.catalogUrl;
          const exclude = this.dataset.exclude;
          const limit = Number(this.dataset.limit || 8);
          if (!track || !url) return;

          const load = () => {
            if (this._loaded) return;
            this._loaded = true;
            fetch(url, { credentials: 'same-origin' })
              .then((response) => (response.ok ? response.text() : Promise.reject()))
              .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const items = [...doc.querySelectorAll('.sf-row__item')].filter(
                  (item) => item.dataset.handle !== exclude
                );
                track.replaceChildren(...items.slice(0, limit));
                if (items.length === 0) this.hidden = true;
              })
              .catch(() => {
                this.hidden = true;
              });
          };

          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                io.disconnect();
                load();
              },
              { rootMargin: '900px 0px' }
            );
            io.observe(this);
          } else {
            load();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
